import { render, staticRenderFns } from "./AccountHeaderSmall.vue?vue&type=template&id=4ed4b238&scoped=true&"
import script from "./AccountHeaderSmall.vue?vue&type=script&lang=js&"
export * from "./AccountHeaderSmall.vue?vue&type=script&lang=js&"
import style0 from "./AccountHeaderSmall.vue?vue&type=style&index=0&id=4ed4b238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4b238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VAvatar,VImg,VSpacer,VToolbar,VToolbarTitle})
